module.exports = __webpack_public_path__ + "img/img-3.92e974f2.png";